<template>
    <div>
        <h1>RENJA REKAPITULASI</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
